/* import __COLOCATED_TEMPLATE__ from './menu.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { restartableTask, timeout } from 'ember-concurrency';
let Menu = (_class = class Menu extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "guid", `${guidFor(this)}-tailwindui-menu`);
    _initializerDefineProperty(this, "items", _descriptor, this);
    _initializerDefineProperty(this, "isOpen", _descriptor2, this);
    _initializerDefineProperty(this, "activeItem", _descriptor3, this);
    _initializerDefineProperty(this, "searchTerm", _descriptor4, this);
  }
  get activeItemIndex() {
    return this.items.indexOf(this.activeItem);
  }
  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
  open() {
    this.isOpen = true;
  }
  close() {
    this.isOpen = false;
  }
  goToFirstItem() {
    let firstItem = this.items.find(item => item.isEnabled);
    this._setActiveItem(firstItem);
  }
  goToLastItem() {
    let lastItem = this.items.slice().reverse().find(item => item.isEnabled);
    this._setActiveItem(lastItem);
  }
  goToPreviousItem() {
    let previousItem = this.items.slice().reverse().find((item, index) => {
      if (this.activeItemIndex !== -1 && this.items.length - index - 1 >= this.activeItemIndex) {
        return false;
      }
      return item.isEnabled;
    });
    this._setActiveItem(previousItem);
  }
  goToNextItem() {
    let nextItem = this.items.find((item, index) => {
      if (index <= this.activeItemIndex) {
        return false;
      }
      return item.isEnabled;
    });
    this._setActiveItem(nextItem);
  }
  goToItem(item) {
    this._setActiveItem(item);
  }
  *searchTask(nextCharacter) {
    this.searchTerm += nextCharacter.toLowerCase();
    const searchResult = this.items.find(item => {
      const textValue = item.element.textContent.toLowerCase().trim();
      return item.isEnabled && textValue.startsWith(this.searchTerm);
    });
    if (searchResult) {
      this._setActiveItem(searchResult);
    }
    yield timeout(350);
    this.searchTerm = '';
  }
  async registerItem(item) {
    let {
      items
    } = this;
    items.push(item);
    await Promise.resolve(() => this.items = items);
  }
  async unregisterItem(item) {
    let {
      items
    } = this;
    let index = items.indexOf(item);
    items.splice(index, 1);
    await Promise.resolve(() => this.items = items);
  }
  _setActiveItem(item) {
    if (item) {
      this.activeItem = item;
      this.items.forEach(item => item.deactivate());
      this.activeItem.activate();
      this.itemsElement.focus();
    }
  }
  get itemsGuid() {
    return `${this.guid}-items`;
  }
  get itemsElement() {
    return document.getElementById(this.itemsGuid);
  }
  get buttonGuid() {
    return `${this.guid}-button`;
  }
  get buttonElement() {
    return document.getElementById(this.buttonGuid);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "items", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "activeItem", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "searchTerm", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "toggle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "open", [action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToFirstItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToFirstItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToLastItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToLastItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToPreviousItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToPreviousItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToNextItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToNextItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchTask", [restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "searchTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unregisterItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unregisterItem"), _class.prototype)), _class);
export { Menu as default };